import { useLocation } from "@reach/router";
import React, { useContext, useState } from "react";
import { useMediaQuery } from "react-responsive";
import bg_video from "../../../assets/new-home-page/bg_graphic_flow.webm";
import graphicPoster from "../../../assets/new-home-page/bg_graphics_poster.webp";
import ModalContext from "../../../Contexts/openModal";
import "../../../styles/components/Slices/HeroDali.scss";
import CustomButton from "../../CustomButton";
import CtaBannerMunchForm from "../../Pieces/CtaBannerMunchForm";
import SingleEmailForm2 from "../../Pieces/SingleEmailForm2";
import VideoComponent from "../../VideoComponent";
import axios from "axios";
import { RUBRIC_EVALUATION_FRAMEWORK_2 } from "../../../constants";
import { toast } from "react-hot-toast";

const downloadFile = async () => {
  return axios({
    url: RUBRIC_EVALUATION_FRAMEWORK_2,
    responseType: "blob",
    method: "GET",
  })
    .then((response) => {
      // Create blob link to download
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `Rubric Evaluation - A Comprehensive Framework for Generative AI Assessment.pdf`);

      // Append to html link element page
      document.body.appendChild(link);

      // Start download
      link.click();

      // Clean up and remove the link
      link.parentNode.removeChild(link);
    })
    .catch((err) => {
      console.error("Error while file download:", err);
    });
};

export const DaliHeroSection = ({ slice, location }) => {
  const { toggleModal, setEmail } = useContext(ModalContext);
  const robotics = location?.pathname === "/the-rise-of-intelligent-machines/";
  const locationHook = useLocation();
  const customers = locationHook?.pathname === "/customers/";
  const RubricPage_2 = location?.pathname === "/rubric-evaluation-generative-ai-assessment-framework/"; 

  const Rectangle =
    slice?.primary?.caption_title_dropdown == "rounded rectangle";
  const PlainHeroText =
    slice?.primary?.caption_title_dropdown == "plain hero text";

  const scrollToSection = (url) => {
    if (url && url?.charAt(0) === "#") {
      const sectionId = url.substring(1);
      const section = document.getElementById(sectionId);
      if (section) {
        const elementPosition = section.getBoundingClientRect().top;
        const offsetPosition = elementPosition + window.scrollY - 70;
        window.scrollTo({ top: offsetPosition, behavior: "smooth" });
      }
    } else toggleModal();
  };
  const isUrl =
    slice?.primary?.secondary_cta_link?.url &&
    slice?.primary?.secondary_cta_link?.url.charAt(0) !== "#";
  const isUrlPrimary =
    slice?.primary?.cta_link?.url &&
    slice?.primary?.cta_link?.url.charAt(0) !== "#";

  const [downloading, setDownloading] = useState(false);

  const handleDownload = async () => {
    setDownloading(true);
      toast.success("Your download has started!");
    try {
      await downloadFile();
    } catch (err) {
    
      console.error("Download failed", err);
    } finally {
      setDownloading(false);
    }
  };

  return (
    <section className="space-y-5 relative lg:max-w-[553px] sm:space-y-7">
      {slice?.primary?.caption_title?.text && (
        <p
          className={`uppercase tracking-widest_1 font-semibold font-manrope ${
            Rectangle
              ? "bg-purple-2001 text-xs rounded-md !text-purple-1100 max-w-fit px-3 py-1.5 "
              : "text-purple-1500 text-xs sm:text-base"
          }`}
        >
          {slice?.primary?.caption_title?.text}
        </p>
      )}
      <div
        role="heading"
        aria-level="2"
        className={`${customers ? "text-2.5xl sm:text-3.25xl lg:text-4.5xl tracking-tightest_6 sm:-tracking-[0.9] leading-9 lg:leading-14 " : slice?.primary?.section_background_image?.url ? "text-white text-3.25xl sm:text-4.5xl dali_strong sm:tracking-tightest_4 tracking-tightest_7 leading-10  sm:leading-[48px]" : " text-purple-1100 text-3.25xl sm:text-[60px] dali_strong sm:-tracking-[3px] tracking-tightest_7 leading-10  sm:leading-[68px]"}  font-medium font-manrope `}
        dangerouslySetInnerHTML={{ __html: slice?.primary?.title?.html }}
      />
      {slice?.primary?.descriptor_text?.text && (
        <div
          className={`text-gray-600 tracking-tight_1 dali-description ${!slice?.primary?.show_bg ? "max-w-full" : "sm:max-w-[550px] lg:max-w-full"}`}
          dangerouslySetInnerHTML={{
            __html: slice?.primary?.descriptor_text?.html,
          }}
        />
      )}

      {slice?.primary?.show_email_cta && robotics ? (
        <CtaBannerMunchForm
          openModal={toggleModal}
          setEmail={setEmail}
          buttonText={slice?.primary?.cta_text?.text || "Get started"}
          formHsClass={slice?.primary?.hs_class?.text}
          formId={slice?.primary?.hs_id?.text}
          pagePath={robotics}
        />
      ) : slice?.primary?.show_email_cta ? (
        <SingleEmailForm2
          openModal={toggleModal}
          setEmail={setEmail}
          buttonText={slice?.primary?.cta_text?.text || "Get started"}
          formHsClass={slice?.primary?.hs_class?.text}
          formId={slice?.primary?.hs_id?.text}
        />
      ) : slice?.primary?.cta_text?.text &&
        slice?.primary?.secondary_cta_text?.text ? (
        <div className="flex flex-col xs:flex-row gap-3">
          {slice?.primary?.cta_text?.text && (
            <CustomButton
              onClick={() => {
                if(RubricPage_2){
                  handleDownload();
                } else if (slice?.primary?.cta_link?.url)  {
                  scrollToSection(slice?.primary?.cta_link?.url);
                }
                else{
                  toggleModal();
                }
              }}
              link={isUrlPrimary && slice?.primary?.cta_link?.url}
              buttonClass="bg-purple-1500 text-white"
              text={slice?.primary?.cta_text?.text}
              disabled={downloading}
            />
          )}
          {slice?.primary?.secondary_cta_link?.url && (
            <CustomButton
              onClick={() => {
                if(slice?.primary?.secondary_cta_link?.url){
                  scrollToSection(slice?.primary?.secondary_cta_link?.url)
                }
                else{
                  toggleModal();
                }
              }}
              link={isUrl && slice?.primary?.secondary_cta_link?.url}
              buttonClass="bg-white hover:border-gray-2500 text-gray-2500 border border-gray-2200"
              text={slice?.primary?.secondary_cta_text?.text}
              target="_blank"
            />
          )}
        </div>
      ) : slice?.primary?.cta_text?.text ? (
        slice?.primary?.cta_link?.url && (
          <CustomButton
            onClick={toggleModal}
            link={slice?.primary?.cta_link?.url}
            buttonClass="bg-purple-1500 text-white"
            text={slice?.primary?.cta_text?.text}
          />
        )
      ) : null}
    </section>
  );
};

export const HeroDali = ({ slice, location }) => {
  const showBg = slice?.primary?.show_bg !== false;
  const backgroundImage = slice?.primary?.background_image?.url;
  const locationHook = useLocation();
  const customers = locationHook?.pathname.includes("/customers/");
  const welcomePage = location?.pathname == "/welcome/";
  const isMobile = useMediaQuery({ maxWidth: 520 });
  const RubricPage_2 = location?.pathname === "/rubric-evaluation-generative-ai-assessment-framework/";

  return (
    <article
      className={` relative ${slice?.primary?.section_background_image?.url ? "py-10 sm:py-20" : !welcomePage && "pt-10"}`}
    >
      {(location?.pathname?.includes("/welcome/") ||
        location.pathname ===
          "/rubric-evaluation-generative-ai-assessment/" || RubricPage_2) &&
        !isMobile && (
          <VideoComponent
            autoPlay
            poster={graphicPoster}
            className="absolute left-0 right-0 z-0 [mix-blend-mode:darken] top-24 lg:top-0 sm:top-16"
          >
            <source
              className="row-start-1 row-end-4"
              src={bg_video}
              type="video/webm"
            />
          </VideoComponent>
        )}

      {slice?.primary?.section_background_image?.url && (
        <img
          className="absolute inset-0 w-full h-full object-cover z-[-1]"
          src={slice?.primary?.section_background_image?.url}
        />
      )}
      <div
        className={`${customers || welcomePage ? "grid grid-cols-1 lg:grid-cols-2 px-4 sm:px-12 lg:px-5 xl:px-0 justify-center items-center max-w-6xl mx-auto" : "full-width-split-screen"}`}
      >
        <DaliHeroSection location={location} slice={slice} />
        <div
          className={`bg_image_dali bg-cover bg-center bg-no-repeat ${!showBg && "lg:max-w-[1020px]"} ${welcomePage && "lg:!my-0 z-20"} `}
          style={{
            backgroundImage: showBg
              ? `url(${backgroundImage || "https://images.prismic.io/encord/Z-5KrHdAxsiBwQl5_daliBg.png?auto=format,compress"})`
              : "none",
          }}
        >
          {/* <GatsbyImage
            image={getImage(slice?.primary?.image)}
            alt="Hero image"
            loading="eager"
            fetchPriority="high"
            sizes="(max-width: 512px) 100vw, 512px,(max-width: 1440px) 720px, 1197px"
            imgClassName="max-w-[1020px]"
          /> */}
          {slice?.primary?.image?.url && (
            <img
              alt="Hero image"
              loading="eager"
              src={slice?.primary?.image?.url}
            />
          )}
        </div>
      </div>
    </article>
  );
};
